import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ServicesSection } from '../components/ServicesSection';
import { HowItWorksSection } from '../components/HowItWorksSection';
import { AboutSection } from '../components/AboutSection';
import { ContactSection } from '../components/ContactSection';
interface HomePageProps {
  isDark: boolean;
}
export function HomePage({
  isDark
}: HomePageProps) {
  return <main data-id="element-510" data-mp="2x1k4c62raw8c">
      <HeroSection isDark={isDark} data-id="element-511" data-mp="2x10nytsr8fwf" />
      <ServicesSection data-id="element-512" data-mp="2s1fpekhhy9k8" />
      <HowItWorksSection data-id="element-513" data-mp="2s1xs9zynzm14" />
      <AboutSection data-id="element-514" data-mp="2s2qr8erdt78p" />
      <ContactSection data-id="element-515" data-mp="2s38wu1zxoxta" />
    </main>;
}